import React, { useCallback, useContext, useMemo, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import {
  getInspectionUrl,
  INSPECTION_URL_TYPE_ROUTE,
} from "../../lib/calculation";
import { getAndForget, postAndForget } from "../../lib/comm";
import {
  MainContext,
  STATUS_ONLINE,
  UIContext,
  UpdateContext,
} from "../../main-context";
import Spinner from "../helpers/Spinner";

export default function SafetyObservation({
  currentMonth,
  inspectionFilter,
  existsInDatabase,
}) {
  const main_context = useContext(MainContext);
  const [searchname, setSearchname] = useState("");
  const update_context = useContext(UpdateContext);
  const history = useHistory();
  const [modal_1, setModal_1] = useState(false);
  const [fade_1, setFade_1] = useState(false);
  const [modal_2, setModal_2] = useState(false);
  const [fade_2, setFade_2] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");

  const safetyReady = useMemo(() => {
    return (
      !!main_context.inspections &&
      !!main_context.inspections.fso &&
      !!main_context.inspections.fso.length
    );
  }, [main_context.inspections]);

  const safetyNoInspections = useMemo(() => {
    return (
      !!main_context.inspections &&
      !!main_context.inspections.fso &&
      !main_context.inspections.fso.length
    );
  }, [main_context.inspections]);

  const fsoFilter = useCallback(
    (fso_filter) => {
      const start = inspectionFilter(fso_filter).filter(
        (x) => x.title.toLowerCase().indexOf(searchname.toLowerCase()) !== -1
      );
      start.sort((a, b) => {
        if (a.title < b.title) return -1;
        if (a.title > b.title) return 1;
        return 0;
      });

      return start;
    },
    [inspectionFilter, searchname]
  );

  const completed = useMemo(() => {
    return fsoFilter("complete");
  }, [fsoFilter]);

  const startModal_1 = useCallback(() => {
    setModal_1(true);
    const options = completed;
    setSelectedUser(options.length ? options : null);
    window.setTimeout(() => setFade_1(true), 1);
  }, [completed]);

  const changeUser = useCallback(
    (id) => {
      const user = completed.find((x) => +x.id === +id);
      setSelectedUser(user);
    },
    [completed]
  );

  const closeModal_1 = useCallback(() => {
    setFade_1(false);
    window.setTimeout(() => setModal_1(false), 300);
  }, []);

  const startModal_2 = useCallback(() => {
    setModal_2(true);
    setFirstName("");
    setLastName("");
    window.setTimeout(() => setFade_2(true), 1);
  }, []);

  const closeModal_2 = useCallback(() => {
    setFade_2(false);
    window.setTimeout(() => setModal_2(false), 300);
  }, []);

  const startInspection = useCallback(
    (inspection) => {
      history.push(
        getInspectionUrl(
          INSPECTION_URL_TYPE_ROUTE,
          inspection,
          update_context.settings.subfolder,
          true
        )
      );
    },
    [history, update_context.settings.subfolder]
  );

  const invalidate = useCallback(
    async (id) => {
      const url = `/fso/invalidate/${id}?type=fso`;
      await getAndForget(url, null, update_context);
      history.push("/");
      history.goBack();
    },
    [history, update_context]
  );

  const adduser = useCallback(
    async (event, start) => {
      const data = { first_name: firstName, last_name: lastName };
      if (start) {
        data["startfso"] = true;
      }
      const url = "/fso/adduser";
      const full_res = await postAndForget(url, data, update_context);
      closeModal_2();
      closeModal_1();
      if (full_res !== "comm_error") {
        const user_error = full_res[0].indexOf(
          "This person is already created. Please check user management."
        );
        if (user_error === -1) {
          console.log(full_res[1].request.responseURL);

          if (!start) {
            history.push("/");
            history.goBack();
          } else {
          }
        } else {
          update_context.update_ui_context((prev) => ({
            ...prev,
            error:
              "This person is already created. Please check user management.",
          }));
        }
      }
    },
    [closeModal_1, closeModal_2, firstName, history, lastName, update_context]
  );

  const countOpenItems = useCallback((inspections) => {
    let i;
    let sum = 0;
    if (inspections && inspections.fso) {
      for (i = 0; i < inspections.fso.length; i++) {
        sum += inspections.fso[i].openItems;
      }
    }
    return sum;
  }, []);

  return (
    <UIContext.Consumer>
      {({ online_status }) => (
        <MainContext.Consumer>
          {({ inspections }) => (
            <div>
              <div className="container">
                <div style={{ display: "inline-block" }}>
                  <h1
                    style={{
                      marginTop: 0,
                      marginRight: "5px",
                      paddingTop: "15px",
                    }}
                  >
                    Ramp Safety Program
                  </h1>
                </div>{" "}
                <div style={{ display: "inline-block" }}>
                  <Link to="/" className="btn btn-xs btn-default">
                    Back to Home
                  </Link>
                </div>{" "}
                <div style={{ display: "inline-block" }}>
                  {(online_status === STATUS_ONLINE && (
                    <button
                      style={{
                        minWidth: "120px",
                        backgroundColor:
                          online_status === STATUS_ONLINE ? "" : "#eaeaea",
                      }}
                      className="btn btn-default btn-xs"
                      onClick={() =>
                        online_status === STATUS_ONLINE &&
                        history.push(
                          update_context.settings.subfolder +
                            "/online-only/fso/infraction"
                        )
                      }
                    >
                      Infraction Log
                    </button>
                  )) || (
                    <span
                      style={{
                        cursor: "text",
                        minWidth: "120px",
                        backgroundColor:
                          online_status === STATUS_ONLINE ? "" : "#eaeaea",
                      }}
                      className="btn btn-default btn-xs"
                    >
                      Infraction Log
                    </span>
                  )}
                </div>{" "}
                <div
                  style={{
                    marginBottom: "7px",
                    marginTop: 0,
                    display: "inline-block",
                  }}
                >
                  {(online_status === STATUS_ONLINE && (
                    <button
                      style={{ minWidth: "120px" }}
                      className="btn btn-default btn-xs"
                      onClick={() => startModal_1()}
                    >
                      New Observation
                    </button>
                  )) || (
                    <span
                      style={{
                        cursor: "text",
                        minWidth: "120px",
                        backgroundColor:
                          online_status === STATUS_ONLINE ? "" : "#eaeaea",
                      }}
                      className="btn btn-default btn-xs"
                    >
                      New Observation
                    </span>
                  )}
                </div>{" "}
                <div
                  style={{
                    display: "inline-block",
                  }}
                >
                  {(online_status === STATUS_ONLINE && (
                    <Link
                      to={
                        update_context.settings.subfolder +
                        "/online-only/fso/leaderboard"
                      }
                      style={{ minWidth: "120px" }}
                      className="btn btn-default btn-xs"
                    >
                      Safety Stats
                    </Link>
                  )) || (
                    <span
                      style={{
                        cursor: "text",
                        minWidth: "120px",
                        backgroundColor:
                          online_status === STATUS_ONLINE ? "" : "#eaeaea",
                      }}
                      className="btn btn-default btn-xs"
                    >
                      Safety Stats
                    </span>
                  )}
                </div>
              </div>

              {!inspections && (
                <h1 className="text-center">
                  Loading...
                  <Spinner className="fa fa-cog fa-spin"></Spinner>
                </h1>
              )}

              <br />
              {safetyNoInspections && (
                <div className="text-center">
                  Please contact support for activation.
                </div>
              )}
              {safetyReady && (
                <div className="container">
                  <br />
                  <div style={{ textAlign: "center" }}>
                    <input
                      className="form-control"
                      style={{ width: "200px", display: "inline-block" }}
                      value={searchname}
                      onChange={(event) => setSearchname(event.target.value)}
                      placeholder="employee search"
                    />
                  </div>
                  <h3 className="text-center">
                    Click an employee to start observation
                  </h3>
                  <div className="row">
                    <div className="col-md-8 text-center">
                      <h2>{currentMonth}</h2>
                      <div className="col-md-6">
                        <ul
                          className="list-unstyled"
                          style={{ height: "250px", overflow: "auto" }}
                        >
                          {fsoFilter("status_obs_accepted").map(
                            (inspection) => (
                              <li key={inspection.id}>
                                <div
                                  title={
                                    inspection.title + " " + inspection.niceType
                                  }
                                  // onClick={() =>
                                  //   checkDueThisPeriod(
                                  //     inspection.dueThisPeriod,
                                  //     inspection.dueDate,
                                  //     inspection.type
                                  //   ) &&
                                  //   existsInDatabase(inspection) &&
                                  //   startInspection(inspection)
                                  // }
                                  className="btn btn-success btn-inspection"
                                >
                                  <span>{inspection.title}</span>
                                </div>
                              </li>
                            )
                          )}
                        </ul>
                      </div>
                      <div className="col-md-6">
                        <ul
                          className="list-unstyled"
                          style={{ height: "250px", overflow: "auto" }}
                        >
                          {fsoFilter("incomplete").map((inspection) => (
                            <li key={inspection.id}>
                              <div
                                style={{
                                  backgroundColor: existsInDatabase(inspection)
                                    ? ""
                                    : "gray",
                                  border: existsInDatabase(inspection)
                                    ? ""
                                    : "1px solid gray",
                                }}
                                title={
                                  inspection.title + " " + inspection.niceType
                                }
                                onClick={() =>
                                  existsInDatabase(inspection) &&
                                  startInspection(inspection)
                                }
                                className="btn btn-danger btn-inspection"
                              >
                                <span>{inspection.title}</span>
                              </div>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                    <div className="col-md-4 text-center">
                      <h2>In Progress</h2>
                      <ul
                        className="list-unstyled"
                        style={{ height: "250px", overflow: "auto" }}
                      >
                        <>
                          {fsoFilter("status_complete_obs_not_accepted").map(
                            (inspection) => (
                              <li key={inspection.id}>
                                <div
                                  title={
                                    inspection.title + " " + inspection.niceType
                                  }
                                  style={{
                                    backgroundColor:
                                      online_status === STATUS_ONLINE
                                        ? ""
                                        : "gray",
                                    border:
                                      online_status === STATUS_ONLINE
                                        ? ""
                                        : "1px solid gray",
                                  }}
                                  onClick={() =>
                                    online_status === STATUS_ONLINE &&
                                    history.push(
                                      update_context.settings.subfolder +
                                        "/online-only/fso/preview/" +
                                        inspection.id
                                    )
                                  }
                                  className="btn btn-primary btn-inspection"
                                >
                                  <span>{inspection.title}</span>
                                </div>
                              </li>
                            )
                          )}
                          {fsoFilter("offline_complete").map((inspection) => (
                            <li key={inspection.id}>
                              <div
                                title={
                                  inspection.title + " " + inspection.niceType
                                }
                                style={{
                                  backgroundColor: "gray",
                                  border: "1px solid gray",
                                }}
                                className="btn btn-primary btn-inspection"
                              >
                                <span>{inspection.title}</span>
                              </div>
                            </li>
                          ))}
                        </>
                      </ul>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 text-center">
                      <h3>
                        <strong>Open Infractions</strong>
                      </h3>
                      <h2>{countOpenItems(inspections)}</h2>
                    </div>
                    <div className="col-md-6 text-center">
                      <h3>
                        <strong>Observations Remaining</strong>
                      </h3>
                      <h2>{fsoFilter("incomplete").length}</h2>
                    </div>
                  </div>
                </div>
              )}

              <div
                id="new-observation-modal"
                className={`modal fade ${fade_1 ? "in" : ""}`}
                role="dialog"
                style={{
                  display: modal_1 ? "block" : "",
                }}
              >
                <div className="modal-dialog modal-sm">
                  <div className="modal-content">
                    <div className="modal-header">
                      <button className="close" onClick={() => closeModal_1()}>
                        &times;
                      </button>
                      <h4 className="modal-title">New Observation</h4>
                    </div>
                    <div className="modal-body">
                      <select
                        value={selectedUser?.id ?? ""}
                        onChange={(event) => changeUser(event.target.value)}
                        className="form-control"
                        size="10"
                      >
                        {completed.map((elem) => (
                          <option key={elem.id} value={elem.id}>
                            {elem.title}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="modal-footer">
                      <span
                        className="btn btn-default pull-left"
                        data-toggle="modal"
                        onClick={() => startModal_2(true)}
                      >
                        Add User
                      </span>
                      {selectedUser && (
                        <span
                          className="btn btn-default"
                          onClick={() => invalidate(selectedUser.id)}
                        >
                          Ok
                        </span>
                      )}

                      <button
                        type="button"
                        className="btn btn-default"
                        onClick={() => closeModal_1()}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div
                id="new-user-modal"
                className={`modal fade ${fade_2 ? "in" : ""}`}
                role="dialog"
                style={{
                  display: modal_2 ? "block" : "",
                }}
              >
                <div className="modal-dialog modal-sm">
                  <div className="modal-content">
                    <div className="modal-header">
                      <button className="close" onClick={() => closeModal_2()}>
                        &times;
                      </button>
                      <h4 className="modal-title">New User</h4>
                    </div>
                    <div className="modal-body">
                      <form method="POST">
                        First name:
                        <br />
                        <input
                          value={firstName}
                          onChange={(event) => setFirstName(event.target.value)}
                        />
                        <br />
                        Last name:
                        <br />
                        <input
                          value={lastName}
                          onChange={(event) => setLastName(event.target.value)}
                        />
                        <br />
                        <br />
                        <span
                          className="btn btn-default"
                          onClick={(event) => adduser(event, false)}
                        >
                          Ok
                        </span>{" "}
                        <button
                          type="button"
                          className="btn btn-default"
                          onClick={() => closeModal_2()}
                        >
                          Cancel
                        </button>{" "}
                        {/* <span
                          className="btn btn-default"
                          onClick={(event) => adduser(event, true)}
                        >
                          Start FSO
                        </span> */}
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </MainContext.Consumer>
      )}
    </UIContext.Consumer>
  );
}
